import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FooterCities = () => {
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const res = await fetch(`${API_URL}/api/service-areas/cities`);
        if (res.ok) {
          const data = await res.json();
          // Get top 15 cities by population (excluding Fort Worth itself)
          const sortedCities = (data.cities || [])
            .filter(c => c.slug !== 'fort-worth')
            .sort((a, b) => b.population - a.population)
            .slice(0, 15);
          setCities(sortedCities);
        }
      } catch (err) {
        console.error('Error fetching cities:', err);
      }
    };
    fetchCities();
  }, []);

  if (cities.length === 0) return null;

  return (
    <div className="border-t border-gray-700 pt-8 mt-8">
      <div className="flex items-center gap-2 mb-4">
        <MapPin className="w-5 h-5 text-teal-400" />
        <h4 className="text-white font-semibold">Cities We Serve</h4>
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-2">
        {cities.map((city, index) => (
          <span key={city.slug}>
            <Link
              to={`/dental-implants-${city.slug}`}
              className="text-gray-400 hover:text-teal-400 text-sm transition"
            >
              {city.name}
            </Link>
            {index < cities.length - 1 && (
              <span className="text-gray-600 ml-4">•</span>
            )}
          </span>
        ))}
        <Link
          to="/areas-we-serve"
          className="text-teal-400 hover:text-teal-300 text-sm font-semibold ml-2"
        >
          View All 53 Cities →
        </Link>
      </div>
    </div>
  );
};

export default FooterCities;
